import React, {memo, Suspense} from "react"
import {useTemplatedComponent} from "@next/templating"
import {MANIFEST} from "@manifest/header"
import connect from "./connect"

export type CounrtySelectorProps = {
    title: string
    territory: string
    iconUrl: string
    isEnableCountrySelectorButton: boolean
    sub: string | null
    openDrawer: (isShowOverlay: boolean) => void
    alteredTerritory: string
    currencyConfig: string
    templating: {
        mainTemplate: string
        fallbackTemplate: string
    }
}

export const BurgerCountrySelector = memo(
    ({
        title,
        territory,
        iconUrl,
        isEnableCountrySelectorButton,
        sub,
        openDrawer,
        alteredTerritory,
        currencyConfig,
        templating,
    }: CounrtySelectorProps) => {
        const TemplatedComponent = useTemplatedComponent(templating, MANIFEST)

        const props = {
            title,
            territory,
            iconUrl,
            isEnableCountrySelectorButton,
            sub,
            openDrawer,
            alteredTerritory,
            currencyConfig,
        }

        return (
            <Suspense>
                <TemplatedComponent {...props} />
            </Suspense>
        )
    },
)

BurgerCountrySelector.displayName = "BurgerCountrySelector"
export default connect(BurgerCountrySelector)
